import { useEffect, useState } from "react";
import ffaLogo from "@/assets/loading-logo.png";

interface BrandedPageLoaderProps {
  message?: string;
}

export default function BrandedPageLoader({ message }: BrandedPageLoaderProps) {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(8);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const start = performance.now();
    let frame = 0;
    const tick = (now: number) => {
      const t = Math.min((now - start) / 1600, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setProgress(8 + eased * 82);
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center gap-5 bg-background"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <img src={ffaLogo} alt="" className="w-20 h-20 object-contain" />
      <div className="w-48 h-1.5 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-primary to-secondary transition-[width] duration-150 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground">{Math.round(progress)}%</p>
      {message && <p className="text-xs text-muted-foreground">{message}</p>}
    </div>
  );
}
